module.exports = {"body":"<p>Decks can provide as much function as there are materials to build the with. Imagine a\nnew Cedar deck allowing you access to a lower back yard. Or a maintenance free\nComposite deck with custom benches for outdoor entertaining.</p>\n<p>However the style or type you need, Enhanced Interiors Remodeling will work for you.</p>\n"}


//////////////////
// WEBPACK FOOTER
// ./work/Decks.md
// module id = 511
// module chunks = 0